import styled from 'styled-components';

export const PlanWrap = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  margin: 0;
  margin-top: 50px;

  & > div {
    width: 100%;
    display: flex;

    &.free_user_plan,
    &.user_professional_plan {
      justify-content: flex-start;
      @media screen and (orientation: portrait) {
        justify-content: center;
      }
    }

    &.user_plan {
      justify-content: flex-end;
      @media screen and (orientation: portrait) {
        justify-content: center;
      }
    }

    &.master_plan {
      justify-content: center;
      @media screen and (orientation: portrait) {
        justify-content: center;
      }
    }

    & > .content {
      width: 100%;
      background: #fff;
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 25px;
      padding-left: 12px;
      padding-right: 12px;
      text-align: center;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > .title_paln {
        font-size: 15px;
        font-weight: 900;
        color: rgba(0,0,0,0.7);
        text-decoration: underline;
        text-transform: uppercase;
        padding-bottom: 12px;
      }

      & > .price {
        font-size: 13px;
        font-weight: 400;
        color: rgba(0,0,0,0.7);
        line-height: 20px;
      }

      & > p {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0,0,0,0.7);
        line-height: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        letter-spacing: 0.4px;
        padding: 0;
        text-align: center;
      }

      & > a {
        width: 205px;
        height: 33px;
        background: #000;
        color: #fff;
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 400;
        letter-spacing: 0.74px;
        border-radius: 50px;
        line-height: 34px;
      }

      @media screen and (orientation: portrait) {
        width: 95%;
      }
    }
  }
  @media screen and (orientation: portrait) {
    row-gap: 10px;
    margin-top: 30px;
  }
`;

export const BottomContent = styled.div`
  width: 100%;
  display: flex;
  margin: 0 !important;
  margin-top: 40px !important;

  & > p {
    font-size: 12px;
    font-weight: 500;
    line-height: 17px;
    text-align: center;
    padding: 0;
    letter-spacing: 0.60px;
    margin: 0;
    @media screen and (orientation: portrait) {
      font-size: 11px;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  @media screen and (orientation: portrait) {
    margin-top: 20px !important;
  }
`;
